<template>
  <div>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card >
        <template slot="actions">
            <vs-button @click="onClickCreateTag" class="mr-4" color="primary" type="filled">Create</vs-button>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-table v-can="'view-user-role'" :max-items="(meta.per_page) ? meta.per_page : 10" @sort="handleSort" :sst="true" :data="invoices" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th>NAME</vs-th>
              <vs-th>DESCRIPTION</vs-th>
              <vs-th>ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr class="cursor-pointer" @click.native="onClickUserView(data[index].id)"  :key="index" v-for="(tr, index) in invoices">

                <vs-td :data="data[index].name">
                  {{ data[index].name }}
                </vs-td>
                <vs-td :data="data[index].status">
                  {{ data[index].description || 'N/A'}}
                </vs-td>
                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip text="View/Update" class="ml-5">
                      <vs-button @click.stop="onClickUserView(data[index].id)"
                                 size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
          <vs-pagination :total="(meta.last_page)? meta.last_page : 1" v-model="page"  class="p-5"></vs-pagination>
        </div>
      </vx-card>
    </div>
  </div>
  <CreateHelpTagCategoryPopUp ref="createHelpTagCategoryPopUp"/>
  </div>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import Filter from '@/mixins/filter';
import ErrorMessages from "@/mixins/ErrorMessages";

const HelpTagRepository = RepositoryFactory.get('helpTag')
import CreateHelpTagCategoryPopUp from "@/components/popups/help-tags/CreateHelpTagCategoryPopUp.vue";

export default {
  name: "HelperTagCategoryList",
  data () {
    return {
      invoices: [],
      meta:{},
      page : 1,
      sort: '',
    }
  },
  mixins:[ErrorMessages],

  components: {
    CreateHelpTagCategoryPopUp
  },
  mounted() {
    this.fetchHelpTagCategoris()
  },
  methods:{
    async refreshData() {
      await this.fetchHelpTagCategoris()
    },
    async fetchHelpTagCategoris() {
      this.$vs.loading()
      try {
        const { data } = await HelpTagRepository.getTagCategories(this.page, 20)
        this.invoices = data.data;
        this.meta.last_page = data.last_page
      } catch(e) {
        console.log(e);
      }
      this.$vs.loading.close()
    },
    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.fetchHelpTagCategoris()
      }

    },
    onClickUserView(id){
      this.$refs.createHelpTagCategoryPopUp.openPopup(id)
    },
    handleChangePage(page) {
      this.page=page;
      this.fetchHelpTagCategoris()
    },
    onClickCreateTag() {
      this.$refs.createHelpTagCategoryPopUp.openPopup()
    }
  },
  watch : {
    page(){
      this.loadInvoiceList()
    }
  },
}
</script>

<style scoped>

</style>
